/* global API */

import dataLayerHelper from '../helpers/dataLayer';

const $changeText = $('.js-change-text');

const changeText = {
  initialize() {
    if ($changeText.length) {
      this.$text = $changeText.find('.js-change-text-text');
      this.$editor = $changeText.find('.js-change-text-editor');
      this.$toggle = $changeText.find('.js-change-text-toggle');
      this.$output = $changeText.find('.js-change-text-output');
      this.$submit = $changeText.find('.js-change-text-submit');
      this.createEvents();
    }
  },

  /**
   * Create events for the change text widget
   * @return {void}
   */
  createEvents() {
    $changeText.on('click', '.js-change-text-toggle', (e) => {
      const isCancel = typeof $(e.currentTarget).data('cancel') !== 'undefined';
      this.toggleUI(isCancel);
    });

    $changeText.on('click', '.js-change-text-submit', () => {
      this.submit();
      dataLayerHelper.event('Note change', 'submit', window.location.href);
    });
  },

  /**
   * Get the value in the textarea (user entered text)
   * @return {String}
   */
  getValue() {
    return this.$editor.find('textarea').val();
  },

  /**
   * Set the textarea value
   * @param {String} text
   * @return {void}
   */
  setValue(text) {
    this.$editor.find('textarea').val(text);
  },

  /**
   * Get the data from all input elements as object for consumption by the API
   * @return {Object}
   */
  getData() {
    const data = {};

    this.$editor.find('input, textarea').toArray().forEach((input) => {
      data[input.name] = input.value;
    });

    return data;
  },

  /**
   * Toggle the widget from editor to preview and vice versa
   * @param {Boolean} isCancel If it's a cancel button that has been pressed
   * @return {void}
   */
  toggleUI(isCancel) {
    const isOpen = this.$editor.is(':visible');

    if (typeof this.initialValue !== 'undefined' && isCancel) {
      this.setValue(this.initialValue);
    }

    if (!isOpen) {
      this.initialValue = this.getValue();
    }

    this.$editor.toggle(!isOpen);
    this.$text.toggle(isOpen);
  },

  /**
   * Submit the data in the editor
   * @return {void}
   */
  submit() {
    // Disable the button and put it in a waiting state
    this.$submit.text('Een moment...').prop('disabled', true);

    // Get the user entered text
    const text = this.getValue();

    // Send the data to the server
    this.postData()
      .then(() => {
        // Enable the button
        this.$submit.text('Opslaan').prop('disabled', false);

        // Toggle back to preview mode
        this.toggleUI(false);

        // Output the entered text to the preview mode
        this.$output.text(text);
      })
      .catch((err) => {
        throw err;
      });
  },

  /**
   * POST text to the API
   * @return {Promise}
   */
  postData() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: API.noteChange,
        type: 'POST',
        data: this.getData(),
        success: (res) => resolve(res),
        error: (xhr, statusText) => reject(new Error(`${statusText} - Note change API`)),
      });
    });
  },
};

export default changeText;
